// Intercom Chat service triggers
document.querySelectorAll("a").forEach((item) => {
  var url = item.href.split("#")[1];
  item.addEventListener("click", (event) => {
    if (url == "messenger") {
      Intercom("showNewMessage");
    }
  });
});

document.querySelectorAll("a").forEach((item) => {
  var url = item.href.split("#")[1];
  item.addEventListener("click", (event) => {
    if (url == "xmessenger") {
      Intercom("hide");
    }
  });
});

document.querySelectorAll(".triggerchat").forEach((item) => {
  item.addEventListener("click", (event) => {
    Intercom("show");
  });
});

document.querySelectorAll(".triggermessages").forEach((item) => {
  item.addEventListener("click", (event) => {
    Intercom("showMessages");
  });
});

document.querySelectorAll(".triggerarticle").forEach((item) => {
  var articleID = item.href.split("#")[1];
  item.addEventListener("click", (event) => {
    console.log(articleID);
    Intercom("showArticle", articleID);
  });
});


// Intercom triggers
document.querySelectorAll("a").forEach((item) => {
  item.addEventListener("click", (event) => {
    if (item.href.includes("intercom")) {
      // Intercom methods
      const methods = ["show", "hide", "showMessages", "showNewMessage"];
      // Show article
      if (item.title.includes("showArticle")) {
        var articleID = item.title.split("showArticle-")[1];
        Intercom("showArticle", articleID);
        console.log("Intercom article ID " + articleID + " opened");
      }
      // Show space - home, messages, help, news & tasks
      else if (item.title.includes("showSpace")) {
        var spaceName = item.title.split("showSpace-")[1];
        Intercom("showSpace", spaceName);
        console.log("Intercom showSpace " + spaceName);
      }
      // Other methods
      else if (methods.includes(item.title)) {
        Intercom(item.title);
        console.log("Intercom " + item.title);
      }
      // Catch if no title
      else {
        Intercom("show");
        console.log("Intercom show");
      }
    }
  });
});